export default "__VITE_ASSET__160997ec__"